export enum ECerfStatus {
  FULLY_APPROVED = 'Fully Approved',
  DENIED = 'Declined',
  PENDING_APPROVAL = 'Pending Approval'
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/interfaces/ECerfStatus.ts